/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".content[_ngcontent-%COMP%]{margin-bottom:20px}.relative[_ngcontent-%COMP%]{position:relative}.fullPage[_ngcontent-%COMP%]{position:absolute;top:0;right:0;left:0;border:0;background:#fff;height:100%;display:flex;justify-content:center;align-items:center;margin-right:-25px;margin-left:-25px;padding:0 40px;flex-direction:column}.otherCard[_ngcontent-%COMP%]{background:var(--primary);border:none;padding:0 20px;height:36px}.textProgress[_ngcontent-%COMP%]{color:#000;margin-bottom:20px}"];
export { styles as styles };
